import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex absolute inset-0 z-10 justify-center pt-32 bg-white/50" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingIndicator',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("l-ring", {
      size: "40",
      color: "#133445"
    }, null, -1)
  ]), 512)), [
    [_vShow, _ctx.isLoading]
  ])
}
}

})